import loadable from '@loadable/component';

const UserListPage = loadable(() => import('./page'));
const UserPage = loadable(() => import('./[id]/form'));

export const routes = [
  {
    path: '',
    element: <UserListPage />,
  },
  {
    path: ':id',
    element: <UserPage />,
  },
];
